import {useEffect} from 'react'
import {useParams, useNavigate} from 'react-router-dom'

import useFetch from 'shared/model/useFetch'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import useRoleCookie from 'shared/model/useRoleCookie'
import getApiRolePath from 'shared/utils/getApiRolePath'

const useGetNoticeDetail = () => {
	const navigate = useNavigate()
	const {idx} = useParams()

	const [fetchResult, fetchRequest] = useFetch()
	const [, setAlert] = useAlertModalAtom()

	const [userRole] = useRoleCookie()
	const rolePath = getApiRolePath(userRole)

	useEffect(() => {
		fetchRequest('GET', `/${rolePath}/notice/${idx}/detail`)
	}, [])

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 400:
				if (fetchResult?.data?.error_code === 'notice_idx')
					setAlert('공지사항 idx를 확인해 주세요.')
				else setAlert('입력한 값의 형식이 잘못되었습니다.')
				break
			case 404:
				if (fetchResult?.data?.error_code === 1) {
					setAlert('공지사항 데이터가 존재하지 않습니다.')
					navigate('/notice')
				}
				break
		}
	}, [fetchResult])

	return [fetchResult]
}

export default useGetNoticeDetail
